import * as yup from 'yup';
import { signupFormSchema } from '@/components/commons/Customer/constants';

export const BUSINESS_EMAIL = 'business@reebelo.com';

export const businessNameField = yup
  .string()
  .trim()
  .max(200, 'Legal business name is too long')
  .required('Legal business name is a required field');

export const businessNameSchema = yup
  .object()
  .shape({ businessName: businessNameField })
  .required();

/** The account sign-up, plus the legal business name. */
export const businessSignupSchema = signupFormSchema
  .shape({ businessName: businessNameField })
  .required();

export type BusinessSignupForm = yup.Asserts<typeof businessSignupSchema>;
export type BusinessNameForm = yup.Asserts<typeof businessNameSchema>;

export const INPUT_CLASS =
  'h-11 w-full rounded border border-gray-700/10 px-3 text-sm text-gray-700 outline-1 outline-gray-700 placeholder:text-gray-700/50';
